import styled from 'styled-components'
import { Timeline, timelineItemClasses } from '@mui/lab'

/** Timeline grows with content; parent Box owns vertical scroll. */
const StyledTimeline = styled(Timeline)({
  margin: 0,
  padding: '0 16px 16px',
  [`& .${timelineItemClasses.root}`]: {
    minHeight: 'auto',
    '&:before': {
      flex: 0,
      padding: 0,
    },
  },
})

export default StyledTimeline
